import React from "react";
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import ShareActions from "./ShareActions";
import {Box, Divider, Typography} from "@mui/material";

const ShareMobile = ({handleClose, isOpen, content}) => {
    return <SwipeableDrawer
        PaperProps={{
            sx:{
                borderTopRightRadius: '8px', borderTopLeftRadius: '8px'
            }
        }}
        ModalProps={{
            BackdropProps: {
                invisible: true
            }
        }}
        sx={{zIndex: 999999}}
        data-testId={"widget-share-modal"}
        anchor={'bottom'} open={isOpen} onClose={handleClose}>
        <Box p={2}>
            <Box display={'flex'} width={'100%'} justifyContent={'center'}>
                <Box onClick={handleClose} bgcolor={'#dddddd'} sx={{height: '4px', borderRadius: '8px', width: '30px', cursor: 'pointer'}}></Box>
            </Box>
        <Box py={1}>
            <Typography>Share</Typography>
        </Box>
        <Divider />
            <ShareActions content={content}/>
        </Box>
    </SwipeableDrawer>
}
export default ShareMobile;